import React from "react";
import { SubscriptionsLoadingDialog } from "./subscriptions-loading-dialog/SubscriptionsLoadingDialog";
import { SubscriptionsCard } from "./SubscriptionsCard";
import { SubscriptionsUIProvider } from "./SubscriptionsUIContext";

export function SubscriptionsPageUnapproved({ history }) {
  const subscriptionsUIEvents = {
  
  };

  return (
    <SubscriptionsUIProvider subscriptionsUIEvents={subscriptionsUIEvents}>
      <SubscriptionsLoadingDialog />
     
      <SubscriptionsCard />
    </SubscriptionsUIProvider>
  );
}
